/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2026-05-07 09:51:32
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-05-07 12:38:34
 * @FilePath: /isp_International/src/util/addressSelection.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getLocal, removeLocal, setLocal } from '@/util/storage';

export const SELECTED_ADDRESS_STORAGE_KEY = 'selected-address';

export interface SelectedAddressSummary {
  addressId: number | string;
  id?: number | string;
  source?: 'manual' | 'default';
  country?: string;
  countryId?: number;
  provinceId?: number;
  cityId?: number;
  districtId?: number;
  countyId?: number;
  countryName?: string;
  provinceName?: string;
  cityName?: string;
  countyName?: string;
  areaAddress?: string;
  detailAddress?: string;
  postalCode?: string;
  receiveName?: string;
  receivePhone?: string;
}

export const getStoredSelectedAddress = (): SelectedAddressSummary | null => {
  const stored = getLocal(SELECTED_ADDRESS_STORAGE_KEY);
  if (!stored) return null;
  if (stored.addressId && !stored.source) {
    return {
      ...stored,
      source: 'manual',
    };
  }
  return stored;
};

export const setStoredSelectedAddress = (address: SelectedAddressSummary) => {
  setLocal(SELECTED_ADDRESS_STORAGE_KEY, address);
};

export const clearStoredSelectedAddress = () => {
  removeLocal(SELECTED_ADDRESS_STORAGE_KEY);
};

const firstDefined = (...values: any[]) => values.find(value => value !== undefined && value !== null && value !== '');

const normalizeAddressValue = (value: any) => `${value ?? ''}`.replace(/\s+/g, ' ').trim();

const isSameValue = (left: any, right: any) => normalizeAddressValue(left) === normalizeAddressValue(right);

const matchesRequiredField = (addressValue: any, submittedValue: any) => {
  if (submittedValue === undefined || submittedValue === null || submittedValue === '') return true;
  if (addressValue === undefined || addressValue === null || addressValue === '') return false;
  return isSameValue(addressValue, submittedValue);
};

const matchesOptionalField = (addressValue: any, submittedValue: any) => {
  if (submittedValue === undefined || submittedValue === null || submittedValue === '') return true;
  if (addressValue === undefined || addressValue === null || addressValue === '') return true;
  return isSameValue(addressValue, submittedValue);
};

export const getAddressId = (address?: any) =>
  firstDefined(address?.id, address?.addressId, address?.addressManagerId, address?.contractId);

export const formatAddressArea = (address?: any) => {
  if (!address) return '';
  return (
    normalizeAddressValue(address.areaAddress) ||
    [address.countryName, address.provinceName, address.cityName, address.countyName]
      .map(normalizeAddressValue)
      .filter(Boolean)
      .join(' ')
  );
};

export const buildSelectedAddressPayload = (
  address: any,
  source: 'manual' | 'default' = address?.source || 'manual',
): SelectedAddressSummary | null => {
  const addressId = getAddressId(address);
  if (!address || !addressId) return null;

  return {
    ...address,
    id: addressId,
    addressId,
    source,
    areaAddress: formatAddressArea(address),
    receiveName: firstDefined(address.receiveName, address.receiverName),
    receivePhone: firstDefined(address.receivePhone, address.receiverPhone),
  };
};

export const findAddressById = (addressList: any[] = [], addressId?: number | string | null) => {
  if (addressId === undefined || addressId === null || addressId === '') return null;
  return addressList.find(item => isSameValue(getAddressId(item), addressId)) || null;
};

export const findAddressBySubmittedAddress = (addressList: any[] = [], submittedAddress?: any) => {
  if (!submittedAddress) return null;

  const submittedReceiveName = firstDefined(submittedAddress.receiveName, submittedAddress.receiverName);
  const submittedReceivePhone = firstDefined(submittedAddress.receivePhone, submittedAddress.receiverPhone);
  const submittedCountry = firstDefined(submittedAddress.country, submittedAddress.countryCode);
  const submittedCountryId = firstDefined(submittedAddress.countryId, submittedAddress.countryArea);

  return (
    addressList.find(item => {
      const itemReceiveName = firstDefined(item.receiveName, item.receiverName);
      const itemReceivePhone = firstDefined(item.receivePhone, item.receiverPhone);

      return (
        matchesRequiredField(itemReceiveName, submittedReceiveName) &&
        matchesRequiredField(itemReceivePhone, submittedReceivePhone) &&
        matchesRequiredField(item.detailAddress, submittedAddress.detailAddress) &&
        matchesOptionalField(item.postalCode, submittedAddress.postalCode) &&
        matchesOptionalField(firstDefined(item.country, item.countryCode), submittedCountry) &&
        matchesOptionalField(firstDefined(item.countryId, item.countryArea), submittedCountryId) &&
        matchesOptionalField(item.provinceId, submittedAddress.provinceId) &&
        matchesOptionalField(item.cityId, submittedAddress.cityId) &&
        matchesOptionalField(item.countyId, submittedAddress.countyId)
      );
    }) || null
  );
};

export const pickAddressByPriority = (
  addressList: any[] = [],
  options: {
    preferredAddressId?: number | string | null;
    submittedAddress?: any;
    storedAddress?: Partial<SelectedAddressSummary> | null;
  } = {},
) =>
  findAddressById(addressList, options.preferredAddressId) ||
  findAddressBySubmittedAddress(addressList, options.submittedAddress) ||
  findAddressById(addressList, options.storedAddress?.addressId) ||
  addressList.find(item => item.defaultStatus === 1) ||
  addressList[0] ||
  null;

export const formatTopAddressLabel = (address?: Partial<SelectedAddressSummary> | null) => {
  if (!address) return '';
  const areaAddress = address.areaAddress?.trim();
  if (areaAddress) return areaAddress;
  const province = address.provinceName?.trim();
  const country = address.countryName?.trim();
  if (province && country) return `${province} ${country}`;
  return province || country || '';
};
